module.exports = __webpack_public_path__ + "static/notification-groups-list-1-9fca043625d58aeee56890bf719f393d.png";